import Aditiya from '../asset/partners/aditya.png';
import Axis from '../asset/partners/axis.png';
import Bajaj from '../asset/partners/bajaj.png';
import Federal from '../asset/partners/federal.png';
import Idfc from '../asset/partners/idfc.png';
import Indusind from '../asset/partners/indusind.png';
import Yes from '../asset/partners/yes.png';
import Hdfc from '../asset/partners/hdfc.png';

import { MDBCarousel, MDBCarouselItem } from 'mdb-react-ui-kit';

export default function Partners(props) {

    const arr = [Bajaj, Indusind, Yes, Hdfc, Idfc, Federal, Aditiya, Axis]

    return (
        <div
            className="w-100 d-flex flex-column justify-content-center align-items-center mb-2"
            style={{
                height: "45%",
                backgroundColor: "#175e80",
                borderTop: "0px solid white"
            }}
        >
            <h2 className=" display-5 fw-bold text-center text-light w-100 pt-2">Our Partners</h2>
            <MDBCarousel interval={2500} className="w-75 d-none d-lg-block d-xl-block d-xxl-block" style={{ height: "75%" }}>
                <MDBCarouselItem itemId={1} className="h-100 w-100">
                    <div className="h-100 w-100 d-flex justify-content-around align-items-center">
                        <div className='h-100 py-2' style={{ width: "33%" }}>
                            <img src={Bajaj} className='d-block h-100 w-100' alt='...' style={{ objectFit: "contain" }} />
                        </div>
                        <div className='h-100 py-2' style={{ width: "33%" }}>
                            <img src={Indusind} className='d-block h-100 w-100' alt='...' style={{ objectFit: "contain" }} />
                        </div>
                        <div className='h-100 py-2' style={{ width: "33%" }}>
                            <img src={Yes} className='d-block h-100 w-100' alt='...' style={{ objectFit: "contain" }} />
                        </div>
                    </div>
                </MDBCarouselItem>
                <MDBCarouselItem itemId={2} className="h-100 w-100">
                    <div className="h-100 w-100 d-flex justify-content-around align-items-center">
                        <div className='h-100 py-2' style={{ width: "33%" }}>
                            <img src={Hdfc} className='d-block h-100 w-100' alt='...' style={{ objectFit: "contain" }} />
                        </div>
                        <div className='h-100 py-2' style={{ width: "33%" }}>
                            <img src={Idfc} className='d-block h-100 w-100' alt='...' style={{ objectFit: "contain" }} />
                        </div>
                        <div className='h-100 py-2' style={{ width: "33%" }}>
                            <img src={Federal} className='d-block h-100 w-100' alt='...' style={{ objectFit: "contain" }} />
                        </div>
                    </div>
                </MDBCarouselItem>
                <MDBCarouselItem itemId={3} className="h-100 w-100">
                    <div className="h-100 w-100 d-flex justify-content-around align-items-center">
                        <div className='h-100 py-2' style={{ width: "33%" }}>
                            <img src={Aditiya} className='d-block h-100 w-100' alt='...' style={{ objectFit: "contain" }} />
                        </div>
                        <div className='h-100 py-2' style={{ width: "33%" }}>
                            <img src={Axis} className='d-block h-100 w-100' alt='...' style={{ objectFit: "contain" }} />
                        </div>
                    </div>
                </MDBCarouselItem>
            </MDBCarousel>
            <MDBCarousel interval={2500} className="w-75 d-block d-lg-none d-xl-none d-xxl-none" style={{ height: "75%" }}>
                {
                    arr?.map((e, i) => {
                        return (
                            <MDBCarouselItem itemId={i + 1} className="h-100 w-100">
                                <div className="h-100 w-100 d-flex justify-content-around align-items-center">
                                    <div className='h-100 py-2' style={{ width: "100%" }}>
                                        <img src={e} className='d-block h-100 w-100' alt='...' style={{ objectFit: "contain" }} />
                                    </div>
                                </div>
                            </MDBCarouselItem>
                        )
                    })
                }

            </MDBCarousel>
        </div>
    )
}